module.exports = __webpack_public_path__ + "static/the-education-of-an-idealist-63480e628d4c4285306ea9839d3733c5.jpg";